import { axiosInstance } from "@/api/axiosInstance";

// Drops empty filters so they are not sent as "status=" etc.
const cleanParams = (params) =>
    Object.fromEntries(
        Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== "")
    );

export const complaintsService = {
    // GET /complaints (superadmin)
    getComplaints: async (page = 0, size = 10, filters = {}) => {
        try {
            const { status, category, search, userId, companyId } = filters;
            const response = await axiosInstance.get("/complaints", {
                params: cleanParams({ page, size, status, category, search, userId, companyId }),
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching complaints:", error.message);
            throw error;
        }
    },

    // GET /complaints/mine (client)
    getMyComplaints: async (page = 0, size = 10, filters = {}) => {
        try {
            const { status, search } = filters;
            const response = await axiosInstance.get("/complaints/mine", {
                params: cleanParams({ page, size, status, search }),
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching my complaints:", error.message);
            throw error;
        }
    },

    // GET /complaints/{id} (owner or superadmin)
    getComplaintById: async (id) => {
        try {
            const response = await axiosInstance.get(`/complaints/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching complaint with ID ${id}:`, error.message);
            throw error;
        }
    },

    // POST /complaints (client)
    createComplaint: async ({ subject, category, message }) => {
        try {
            const response = await axiosInstance.post("/complaints", {
                subject,
                message,
                ...(category && { category }),
            });
            return response.data;
        } catch (error) {
            console.error("Error creating complaint:", error.message);
            throw error;
        }
    },

    // POST /complaints/{id}/messages (owner or superadmin), refused once resolved
    replyToComplaint: async (id, message) => {
        try {
            const response = await axiosInstance.post(`/complaints/${id}/messages`, { message });
            return response.data;
        } catch (error) {
            console.error(`Error replying to complaint with ID ${id}:`, error.message);
            throw error;
        }
    },

    // PATCH /complaints/{id}/resolve (superadmin)
    resolveComplaint: async (id, message = "") => {
        try {
            const response = await axiosInstance.patch(
                `/complaints/${id}/resolve`,
                message.trim() ? { message: message.trim() } : {}
            );
            return response.data;
        } catch (error) {
            console.error(`Error resolving complaint with ID ${id}:`, error.message);
            throw error;
        }
    },
};

export const COMPLAINT_STATUSES = ["OPEN", "ANSWERED", "RESOLVED"];

export const COMPLAINT_CATEGORIES = [
    "BILLING",
    "SURVEY",
    "CAMPAIGN",
    "FOCUS_GROUP",
    "GIFT",
    "ACCOUNT",
    "OTHER",
];